import type { WatermarkDataPoint } from '@frameio/graphql-client/generated';
import { theme } from '@frameio/vapor';
import {
  BLOCK_LINE_HEIGHT_MAPPINGS,
  BLOCK_SIZE_MAPPINGS,
  DATA_POINT_DEFAULT_VALUES,
} from '../../constants';
import WatermarkTemplateBlockMarquee from './WatermarkTemplateBlockMarquee';

type WatermarkTemplateBlockProps = {
  isAnimationPaused?: boolean;
  positionMaxX?: number;
  scaleX?: number;
  value: {
    alpha?: number;
    dataPoints?: Array<WatermarkDataPoint>;
    fontSize?: string;
    scrollText?: string;
    textColor?: string;
    textShadow?: boolean;
  };
};

const WatermarkTemplateBlock = (props: WatermarkTemplateBlockProps) => {
  const {
    isAnimationPaused,
    positionMaxX,
    scaleX,
    value: {
      alpha,
      dataPoints = {},
      fontSize: textSize,
      scrollText: textScrollDirection,
      textColor = theme.colors.text.body,
      textShadow,
    } = {},
  } = props;

  const linesOfText = Object.values(dataPoints)
    .map(
      ({ __typename, value }) => value || DATA_POINT_DEFAULT_VALUES[__typename]
    )
    .map((value) => (typeof value === 'function' ? value() : value));

  return (
    <div
      style={{
        color: textColor,
        opacity: alpha,
        fontSize: `${BLOCK_SIZE_MAPPINGS[textSize] * scaleX}px`,
        fontWeight: theme.fontWeights.medium,
        lineHeight: `${BLOCK_LINE_HEIGHT_MAPPINGS[textSize] * scaleX}px`,
        textShadow: textShadow ? '1px 1px 2px black' : 'unset',
        userSelect: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      {textScrollDirection === 'NONE' ? (
        linesOfText.map((value, i) => <div key={i}>{value}</div>)
      ) : (
        <WatermarkTemplateBlockMarquee
          isAnimationPaused={isAnimationPaused}
          isReverse={textScrollDirection === 'RIGHT_TO_LEFT'}
          scaleX={scaleX}
          targetPosition={Math.round(positionMaxX)}
        >
          {linesOfText.join(' | ')}
        </WatermarkTemplateBlockMarquee>
      )}
    </div>
  );
};

export default WatermarkTemplateBlock;
